@if (planDetail) {

  <form [formGroup]="planDetailForm"
        (ngSubmit)="savePlanDetail()"
        autocomplete="off"
        novalidate>

    <div class="row">

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Year</span>
          @if (yearDropdown.invalid && (yearDropdown.dirty || yearDropdown.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <ng-select formControlName="yearDropdown"
                     bindLabel="description"
                     appendTo="body"
                     [clearable]="false"
                     (change)="onYearChange($event)"
                     required>
             @for (year of years; track year.code) {
             <ng-option [value]="year">{{year.description}}</ng-option>
             }
          </ng-select>
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="adjustedShareOffer.invalid && (adjustedShareOffer.dirty || adjustedShareOffer.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Adj. Off</span>
          @if (adjustedShareOffer.invalid && (adjustedShareOffer.dirty || adjustedShareOffer.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="adjustedShareOffer"
                 type="text"
                 mask="separator.0"
                 name="adjustedShareOffer"
                 [allowNegativeNumbers]="true"
                 thousandSeparator=","
                 maxlength="9"
                 class="form-control text-right" />
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="purchasedShares.invalid && (purchasedShares.dirty || purchasedShares.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Purchases</span>
          @if (purchasedShares.invalid && (purchasedShares.dirty || purchasedShares.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="purchasedShares"
                 type="text"
                 mask="separator.0"
                 thousandSeparator=","
                 [allowNegativeNumbers]="true"
                 maxlength="9"
                 name="purchasedShares"
                 class="form-control text-right" />
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="repurchasedShares.invalid && (repurchasedShares.dirty || repurchasedShares.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Repurchases</span>
          @if (repurchasedShares.invalid && (repurchasedShares.dirty || repurchasedShares.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="repurchasedShares"
                 type="text"
                 mask="separator.0"
                 thousandSeparator=","
                 [allowNegativeNumbers]="true"
                 maxlength="9"
                 name="repurchasedShares"
                 class="form-control text-right" />
        </div>

      </div>

    </div>

    <div class="row mt-3">

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="repurchasedAmount.invalid && (repurchasedAmount.dirty || repurchasedAmount.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Repur. $</span>
          @if (repurchasedAmount.invalid && (repurchasedAmount.dirty || repurchasedAmount.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="repurchasedAmount"
                 type="text"
                 name="repurchasedAmount"
                 class="form-control text-right"
                 mask="separator.2"
                 [allowNegativeNumbers]="true"
                 thousandSeparator=","
                 maxlength="13"/>
          <!-- currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.' }"-->
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="evergreenShares.invalid && (evergreenShares.dirty || evergreenShares.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Evergreen</span>
          @if (evergreenShares.invalid && (evergreenShares.dirty || evergreenShares.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="evergreenShares"
                 type="text"
                 mask="separator.0"
                 thousandSeparator=","
                 [allowNegativeNumbers]="true"
                 maxlength="9"
                 name="evergreenShares"
                 class="form-control text-right" />
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group"
             [class.error]="evergreenVestedShares.invalid && (evergreenVestedShares.dirty || evergreenVestedShares.touched || mouseoverPlanDetailSubmit)">
          <span class="fake-label">Vested</span>
          @if (evergreenVestedShares.invalid && (evergreenVestedShares.dirty || evergreenVestedShares.touched || mouseoverPlanDetailSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="evergreenVestedShares"
                 type="text"
                 mask="separator.0"
                 thousandSeparator=","
                 [allowNegativeNumbers]="true"
                 maxlength="9"
                 name="evergreenVestedShares"
                 class="form-control text-right" />
        </div>

      </div>

      <div class="col-sm-3 col-button text-center">

        @if (canEdit) {
          <span (mouseenter)="mouseoverPlanDetailSubmit=true" (mouseleave)="mouseoverPlanDetailSubmit=false">
            <app-button [buttonConfig]="{textChange: ['Add', 'Update']}"
                        [textChangeIndex]="+(!!(planDetail.id))"
                        [isLoading]="isSubmitting"
                        [disabled]="!planDetailForm.valid || isSubmitting"
                        (textBtnClickEmt)="savePlanDetail()"></app-button>
          </span>
        }

      </div>

    </div>

  </form>

  <!-- large spacer to allow full view of year dropdown in the case this is a new record -->
  <!--@if (!planDetail?.id) { <div class="mt-5 mb-5"><div class="pt-4">&nbsp;</div></div> }-->

}
